import { useFeatureFlags } from './useFeatureFlags';

/**
 * Giá nạp Ca — PHẢI khớp tuyệt đối với BE (CreatePaymentUrlHandler):
 *   actualAmount (đơn vị VND×100) = (long)(base × (100 + grossUpPercent)) + fixedFeeVnd × 100
 * Số Ca cộng vào ví tính trên MỆNH GIÁ GỐC (CheckIpnHandler), KHÔNG tính trên số đã cộng phí.
 *
 * Các hệ số lấy từ cấu hình đang chạy (admin đổi ở Settings là FE đổi theo), không hard-code.
 * Hằng số dưới đây chỉ là lưới an toàn cho lúc chưa tải xong / gọi lỗi.
 */
const FALLBACK = { percent: 3, fixed: 2200, vndPerCa: 1, minVnd: 10000, maxVnd: 0 };

const num = (raw: string, fallback: number) => {
  if (raw === '' || raw == null) return fallback;
  const n = Number(raw);
  return Number.isFinite(n) ? n : fallback;
};

export const useTopupPricing = () => {
  const { get } = useFeatureFlags();
  const percent = num(get('topup.grossUpPercent'), FALLBACK.percent);
  const fixed = num(get('topup.fixedFeeVnd'), FALLBACK.fixed);
  const vndPerCa = Math.max(1, num(get('topup.vndPerCa'), FALLBACK.vndPerCa));
  const minVnd = num(get('topup.minVnd'), FALLBACK.minVnd);
  const maxVnd = num(get('topup.maxVnd'), FALLBACK.maxVnd);

  // Làm tròn LÊN khi hiển thị: thà trùng khít số cổng thu, tuyệt đối không hiện thấp hơn
  // số người dùng sẽ phải trả ở màn thanh toán.
  const chargeVnd = (baseVnd: number) =>
    Math.ceil(Math.floor(baseVnd * (100 + percent)) / 100 + fixed);
  const feeVnd = (baseVnd: number) => chargeVnd(baseVnd) - baseVnd;
  const caFor = (baseVnd: number) => Math.floor(baseVnd / vndPerCa);

  /** Mô tả phí để hiện cho người dùng, ví dụ "3% + 2.200đ/giao dịch". */
  const feeLabel = `${percent}% + ${fixed.toLocaleString('vi-VN')}đ/giao dịch`;

  return { percent, fixed, vndPerCa, minVnd, maxVnd, chargeVnd, feeVnd, caFor, feeLabel };
};
